import type { FC } from 'react';
import { Button, Form, InlineLoading, InlineNotification, Stack, TextInput } from '@carbon/react';

import { TAMANHO_DO_CODIGO } from '../../../logica/auth/useCodigoDoEmail';
import { ROTULOS, rotuloDoAviso } from '../../padroes/rotulos';
import styles from './auth.module.scss';

// A CONFIRMAÇÃO DO E-MAIL POR CÓDIGO — um `TextInput` numérico só (o Carbon não tem campo de PIN, e
// seis caixas próprias seriam um controle inventado). O teclado do celular sugere o código que
// chegou (`one-time-code`); com o sexto dígito, confirma sozinho.

export interface PropsDoCodigo {
  email: string;
  codigo: string;
  setCodigo: (v: string) => void;
  loading: boolean;
  error: string | null;
  info: string | null;
  espera: number;
  confirmar: () => void;
  reenviar: () => void;
}

export const CodigoDoEmail: FC<PropsDoCodigo> = ({
  email, codigo, setCodigo, loading, error, info, espera, confirmar, reenviar,
}) => (
  <Form noValidate onSubmit={(e) => { e.preventDefault(); confirmar(); }}>
    <Stack gap={6}>
      <p className={styles.texto}>
        Digite o código de {TAMANHO_DO_CODIGO} dígitos que enviamos para <strong className={styles.destaque}>{email}</strong>.
        O código expira em 1 hora.
      </p>
      <TextInput
        id='codigo-do-email'
        labelText='Código de confirmação'
        inputMode='numeric'
        autoComplete='one-time-code'
        maxLength={TAMANHO_DO_CODIGO}
        value={codigo}
        onChange={(e) => setCodigo(e.target.value)}
        helperText='Criou a conta com o Google? O código não chega: entre pelo Google.'
        autoFocus
      />
      {error && <InlineNotification kind='error' lowContrast hideCloseButton title={error} statusIconDescription={rotuloDoAviso('error')} aria-label={ROTULOS.fecharAviso} />}
      {info && <InlineNotification kind='info' lowContrast hideCloseButton title={info} statusIconDescription={rotuloDoAviso('info')} aria-label={ROTULOS.fecharAviso} />}
      <div className={styles.acoes}>
        {loading
          ? <InlineLoading description='Confirmando…' iconDescription={ROTULOS.carregando} />
          : <Button type='submit' disabled={codigo.length < TAMANHO_DO_CODIGO}>Confirmar e entrar</Button>}
        <Button kind='ghost' onClick={reenviar} disabled={espera > 0}>
          {espera > 0 ? `Reenviar em ${espera}s` : 'Reenviar código'}
        </Button>
      </div>
    </Stack>
  </Form>
);
